import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Element } from 'react-scroll';
import {
  noop,
  get,
} from 'lodash';
import { compose, setDisplayName } from 'recompose';
import { withTracker } from 'components/Tracker';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import SearchBar from 'material-ui-search-bar';
import CaretDown from '@material-ui/icons/KeyboardArrowDown';
import CaretUp from '@material-ui/icons/KeyboardArrowUp';
import Login from './components/Login';
import RecoverPasswordDialog from './components/RecoverPasswordDialog';
import VerificationDialog from './components/VerificationDialog';
import SignUp from './components/SignUp';
import Sort from '@material-ui/icons/UnfoldMore';
import qs from 'qs';

import immutableToJS from 'helpers/immutableToJS';
import { dispatchRestMaker, getFullNameOrEmail } from 'helpers/utils';
import {
  injectIntl,
  Paper,
  BasicFooter,
  Avatar,
  SearchComponent
} from 'components';
import { clearAuthToken } from 'redux/auth/actions';
import marketPlaceActions from 'redux/marketPlace/actions';
import { selectState } from 'redux/selectors';
import StoreCardDetails from './components/StoreCardDetails';
import { Link } from 'react-router-dom';
import { Nav } from 'reactstrap';
import { isMobile } from 'helpers/detect-mobile';
import Button from '@material-ui/core/Button';


const styles = () => ({
  element: { padding: '20px 20px' },
  rootSearch: {
    flexDirection: 'row-reverse',
    transition: 'width 1s',
    zIndex: 1201,
    height: '50px',
    width:'350px'
  },
  icon: {
    color: 'grey',
    height: 15,
    width: 15,
  },
  iconOpen: {
    opacity: 1,
    color: '#4695ec !important',
  },
  iconButton: { opacity: 1 },
  searchContainer: {
    width: 'calc(100% - 48px - 16px)',
    margin: 'auto 16px auto 0',
  },
  searchIconButton: {
    marginRight: 0,
    marginLeft: -48,
    padding: 0,
  },
  paper: { paddingBottom: 55 },
});

class MarketPlace extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    brands: PropTypes.shape({}),
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
      }).isRequired,
    }).isRequired,
    marketPlaces: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,
    sellers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,
    marketPlacesRequesting: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired,
    listMarketPlaces: PropTypes.func.isRequired,
    tokenInfo: PropTypes.shape({}).isRequired,
    clearAuthToken: PropTypes.func.isRequired,
  };

  static defaultProps = {
    marketPlacesRequesting: false,
  };

  constructor(props) {
    super(props);
    const valueString = props.history.location.search.slice(1);
    const { search } = qs.parse(valueString);

    this.state = {
      hasSearchText: !!search,
      searchText: search,
      sortDirection: '',
      movingRight: false,
      movingLeft: false,
      email: '',
    };
  }

  componentWillMount() {
    const { isConsumer } = this.context;
    const { history, listMarketPlaces } = this.props;
    const valueString = history.location.search.slice(1);
    const { search } = qs.parse(valueString);
    if (isConsumer) {
      listMarketPlaces({ search, isConsumer });
    } else {
      listMarketPlaces({ search });
    }
  }

  componentDidMount() {
    document.body.classList.add('body-marketplace');

    let queryParams = [];
    let query;

    if (this.props.history.location.hash !== '') {
      query = (this.props.history.location.hash.split('/')).length > 1 ? (this.props.history.location.hash.split('/')[1] || '').split('?')[1] : (this.props.history.location.hash.split('/')[0] || '').split('?')[1];
      queryParams = qs.parse(query);
    } else if (this.props.history.location.search !== '') {
      query = this.props.history.location.search.slice(1);
      const queryValue = decodeURIComponent(query).split('/').length > 1 ? (decodeURIComponent(query).split('/')[1] || '').split('?')[1] : (decodeURIComponent(query).split('/')[0] || '').split('?')[1];
      queryParams = qs.parse(queryValue);
    }
    
    if (queryParams && queryParams.email) {
      this.setState({ email: queryParams.email });
    }
  }

  componentWillReceiveProps(nextProps) {
    const valueString = nextProps.history.location.search.slice(1);
    const { search } = qs.parse(valueString);

    if (search) {
      this.setState({
        hasSearchText: true,
        searchText: search,
      });
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('body-marketplace');
  }

  onChangeSearchText = searchText => this.setState({ searchText });

  onSortTimeStamp = () => {
    const { sortDirection } = this.state;
    const nextSortDirection = !sortDirection ? 'asc' : {
      asc: 'desc',
      desc: '',
    }[sortDirection];

    this.setState({ sortDirection: nextSortDirection });
  }

  onSearch = (searchText) => {
    const { isConsumer } = this.context;
    const { history, listMarketPlaces } = this.props;
    if (isConsumer) {
      listMarketPlaces({ search: searchText, isConsumer });
    } else {
      listMarketPlaces({ search: searchText });
    }
    history.push(`${history.location.pathname}?search=${searchText}`);
  }



  get showSignup() {
    const {
      history: {
        location: {
          hash,
        },
      },
    } = this.props;

    return hash.split('?')[0] === '#signup';
  }

  switchForms = () => {
    const { history } = this.props;
    const { showSignup } = this;
    if (showSignup) {
      this.setState({ movingLeft: true });
      setTimeout(() => this.setState({ movingLeft: false }), 200);
    } else {
      this.setState({ movingRight: true });
      setTimeout(() => this.setState({ movingRight: false }), 100);
    }
    setTimeout(() => history.push(`/marketplace/#${showSignup ? 'login' : 'signup'}`), 100);
  }

  render() {
    const {
      classes,
      formatMessage,
      history,
      marketPlaces,
      marketPlacesRequesting,
      sellers,
      tokenInfo,
      clearAuthToken,
    } = this.props;
    const {
      hasSearchText,
      searchText,
      sortDirection,
      movingRight,
      movingLeft,
    } = this.state;
    const {
      currentUser,
      brands,
      isConsumer,
    } = this.context;

    const { accessToken } = tokenInfo.toJS() || {};
    const { hash } = history.location;
    const [subPath, query] = (hash.split('/')[1] || '').split('?');
    const { showSignup } = this;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const iconDirectionForOrder = {
      asc: <CaretUp className={classes.icon} />,
      desc: <CaretDown className={classes.icon} />,
    }[sortDirection] || <Sort className={classes.icon} />;

    let filterdMarketPlaces = marketPlaces;
    if (process.env.API_BASE_URL === 'https://api-v2.freshr.com/api') {
      filterdMarketPlaces = marketPlaces.length > 0 ? (marketPlaces.filter(market => market.user && !market.user.account.test)) : marketPlaces;
    }

    const fullNameOrEmail = currentUser && currentUser.id ? getFullNameOrEmail(currentUser.account) : '';
    const id = currentUser && currentUser.organizations && currentUser.organizations.length > 0 && currentUser.organizations[0].id;
    const account = currentUser && currentUser.organizations && currentUser.organizations.length > 0 && currentUser.organizations[0].account;
    const email = account && account.email;
    const profile = account && account.profile;
    const companyName = profile && profile.companyName;
    const logoUrl = profile && profile.logoUrl;
    const clickable = true;
    let recoverPasswordDialog = null;
    let verificationDialog = null;
    if (subPath === 'passwordRecovery') {
      const valueStrings = query.split('&');
      const queryParams = {};

      valueStrings.forEach((valueString) => {
        const [name, value] = valueString.split('=');
        queryParams[name] = value;
      });

      recoverPasswordDialog = (
        <RecoverPasswordDialog
          {...queryParams}
          formatMessage={formatMessage}
          push={history.push}
        />
      );
      clearAuthToken();
    } else if (subPath === 'verifyEmail') {
      const valueStrings = query.split('&');
      const queryParams = {};
      valueStrings.forEach((valueString) => {
        const [name, value] = valueString.split('=');
        queryParams[name] = value;
      });
      verificationDialog = (
        <VerificationDialog
          {...queryParams}
          formatMessage={formatMessage}
          push={history.push}
        />
      );
      clearAuthToken();
    }

    return (
      <div className="marketplace-page store-page vh_height100">
        <header
          className="app-header navbar"
          style={{
            backgroundColor: 'white',
            color: 'black',
            justifyContent: 'space-between',
          }}
        >
          <div className="d-flex align-items-center">
            <Link to="/">
              <img
                alt="sun"
                className="home-logo"
                src={brands.logoUrl}
              />
            </Link>
            <Nav navbar>
            {!isMobile && 
              <React.Fragment>
                 <Link to="/marketplace">
                  <h3 className="header-title" style={{ marginLeft: 15, marginRight: 30 }}> {formatMessage('Marketplace')}</h3>
                </Link>
                <SearchBar
                  autoFocus
                  onChange={this.onChangeSearchText}
                  onKeyPress={(e) => {
                    if (e.which === 13) {
                      this.onSearch(e.target.value);
                    }
                  }}
                  onRequestSearch={noop}
                  placeholder={formatMessage('Search Items')}
                  value={searchText}
                  classes={{
                    root: classes.rootSearch,
                    icon: classes.iconOpen,
                    iconButton: classes.iconButton,
                    searchContainer: classes.searchContainer,
                    searchIconButton: classes.searchIconButton,
                  }}
                />
              </React.Fragment>
              }
            </Nav>
          </div>
          <div>
          {!accessToken && (
            <React.Fragment>
              <Button
                style={{marginRight:isMobile ? 20 : 30}}
                variant="contained" 
                color="primary"
                component={ Link } to="/#login"
              >
              Log in
              </Button>
              <Button
                style={{marginRight:isMobile ? 10 : 50}}
                variant="contained" 
                color="primary"
                component={ Link } to="/#signup"
              >
              Sign Up
              </Button>
            </React.Fragment>
          )}
          </div>
        </header>
      
        <Element className={classes.element}>
          <div className={`${accessToken ? '' : 'row'}`}>
            <div className={`${accessToken ? '' : 'col-md-9'}`} style={{ marginBottom: `${accessToken ? '0' : '15px'}` }}>
              {isMobile && 
                <React.Fragment>
                  <div style={{ fontSize: '20px', padding: '10px 0px' }}>Marketplace</div>
                  <SearchBar
                    autoFocus
                    onChange={this.onChangeSearchText}
                    onKeyPress={(e) => {
                      if (e.which === 13) {
                        this.onSearch(e.target.value);
                      }
                    }}
                    onRequestSearch={noop}
                    placeholder={formatMessage('Search Items')}
                    value={searchText}
                    classes={{
                      root: classes.rootSearch,
                      icon: classes.iconOpen,
                      iconButton: classes.iconButton,
                      searchContainer: classes.searchContainer,
                      searchIconButton: classes.searchIconButton,
                    }}
                  />
                </React.Fragment>
              }
            </div>
          </div>
          <div className={`market-place-overlap-products-product ${!hasSearchText ? 'no-search-text' : ''}`}>
            <Paper
              loading={marketPlacesRequesting}
              className={classes.paper}
              padding={0}
            >
              {
                marketPlacesRequesting && !filterdMarketPlaces.length && (
                  <div className="store-progress">
                    <CircularProgress />
                  </div>
                )
              }
              <StoreCardDetails
                details={filterdMarketPlaces}
                history={history}
                iconDirectionForOrder={iconDirectionForOrder}
                onSortTimeStamp={this.onSortTimeStamp}
                sortDirection={sortDirection}
                sellers={sellers}
                isMobile={isMobile}
                accessToken={accessToken}
              />
            </Paper>
          </div>
        </Element>
        {recoverPasswordDialog}
        {verificationDialog}
        <BasicFooter />
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('marketPlace', 'marketPlaces')(state),
  ...selectState('sellers', 'sellers')(state),
  ...selectState('auth', 'tokenInfo')(state),
});
/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  clearAuthToken: payload => dispatch(clearAuthToken(payload)),
  ...dispatchRestMaker([
    [marketPlaceActions, 'marketPlace'],
  ])(dispatch),
});

export default compose(
  setDisplayName('MarketPlace'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
  withTracker,
)(MarketPlace);
